export default "__VITE_ASSET__DSdxbk4m__"